import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import { AddToTalentListDrawerContent } from 'modules/candidate-profile/components';

type UseAddToTalentListDrawerProps = {
  selectedCandidateIds: string[];
  onAddToList?: () => Promise<void>;
};

export const useAddToTalentListDrawer = () => {
  const { openDrawer } = useDrawerV2();

  const openAddToTalentListDrawer = ({
    selectedCandidateIds,
    onAddToList
  }: UseAddToTalentListDrawerProps) => {
    openDrawer({
      title: 'Add to talent list',
      width: '700px',
      children: (
        <AddToTalentListDrawerContent
          selectedCandidateIds={selectedCandidateIds}
          onAddToList={onAddToList}
        />
      )
    });
  };

  return { openAddToTalentListDrawer };
};
